/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VAPIDKeys } from './VAPIDKeys';
import {
    VAPIDKeysFromJSON,
    VAPIDKeysFromJSONTyped,
    VAPIDKeysToJSON,
    VAPIDKeysToJSONTyped,
} from './VAPIDKeys';

/**
 * 
 * @export
 * @interface ShowVAPIDKeyResponse
 */
export interface ShowVAPIDKeyResponse {
    /**
     * 
     * @type {VAPIDKeys}
     * @memberof ShowVAPIDKeyResponse
     */
    data: VAPIDKeys;
}

/**
 * Check if a given object implements the ShowVAPIDKeyResponse interface.
 */
export function instanceOfShowVAPIDKeyResponse(value: object): value is ShowVAPIDKeyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowVAPIDKeyResponseFromJSON(json: any): ShowVAPIDKeyResponse {
    return ShowVAPIDKeyResponseFromJSONTyped(json, false);
}

export function ShowVAPIDKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowVAPIDKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': VAPIDKeysFromJSON(json['data']),
    };
}

  export function ShowVAPIDKeyResponseToJSON(json: any): ShowVAPIDKeyResponse {
      return ShowVAPIDKeyResponseToJSONTyped(json, false);
  }

  export function ShowVAPIDKeyResponseToJSONTyped(value?: ShowVAPIDKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': VAPIDKeysToJSON(value['data']),
    };
}

